import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getTransactionTypeTranslationKey(type: Enums<"transactionType">): TranslationKey {
	switch (type) {
		case "correction":
			return "stock.transaction_types.correction";
		case "pick":
			return "stock.transaction_types.pick";
		case "inventory":
			return "stock.transaction_types.inventory";
		case "restock":
			return "stock.transaction_types.restock";
		case "return":
			return "stock.transaction_types.return";
	}
}
